(function () {
  'use strict';

  var PHONE = '972533364670';

  function getMessage() {
    var url = window.location.href;
    var isProduct = document.body.querySelector('[data-template="product"]') !== null
      || window.location.pathname.indexOf('/products/') !== -1;
    var isHebrew = document.documentElement.lang === 'he';

    if (isProduct) {
      return isHebrew
        ? '\u05D4\u05D9\u05D9 \u05E0\u05E2\u05D4, \u05D9\u05E9 \u05DC\u05D9 \u05E9\u05D0\u05DC\u05D4 \u05DC\u05D2\u05D1\u05D9 \u05D4\u05DE\u05D5\u05E6\u05E8 \u05D4\u05D6\u05D4: ' + url
        : 'Hi Noa, I have a question about this product: ' + url;
    }
    return isHebrew
      ? '\u05D4\u05D9\u05D9 \u05E0\u05E2\u05D4, \u05D9\u05E9 \u05DC\u05D9 \u05E9\u05D0\u05DC\u05D4 \u05DC\u05D2\u05D1\u05D9 visions.'
      : 'Hi Noa, I have a question about visions.';
  }

  function getWhatsAppURL() {
    var msg = encodeURIComponent(getMessage());
    return 'https://wa.me/' + PHONE + '?text=' + msg;
  }

  function init() {
    var btn = document.getElementById('whatsapp-fab');
    if (!btn) return;

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.open(getWhatsAppURL(), '_blank', 'noopener,noreferrer');
    });

    btn.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        window.open(getWhatsAppURL(), '_blank', 'noopener,noreferrer');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
